import React from "react";
import moment from "moment";
import "moment-timezone";
import { IconUpArrow } from "icons";
const timeConstraints = {
  hours: {
    min: 0,
    max: 23,
    step: 1,
  },
  minutes: {
    min: 0,
    max: 59,
    step: 1,
  },
  seconds: {
    min: 0,
    max: 59,
    step: 1,
  },
  milliseconds: {
    min: 0,
    max: 999,
    step: 1,
  },
};

function createConstraints(overrideTimeConstraints) {
  let constraints = {};

  Object.keys(timeConstraints).forEach((type) => {
    constraints[type] = { ...timeConstraints[type], ...(overrideTimeConstraints[type] || {}) };
  });

  return constraints;
}

function formatNum(value) {
  if (value < 10) return "0" + value;
  return value;
}

export default class TimeView extends React.Component {
  constructor(props) {
    super(props);

    this.constraints = createConstraints(props.timeConstraints);

    // This component buffers the time part values in the state
    // while the user is pressing down the buttons
    // and call the prop `setTime` when the buttons are released
    this.default = props.selectedDate ? false : true;

    this.state = this.getTimeParts(props.selectedDate || moment().tz(props.displayTimeZone || ""));
  }

  render() {
    let items = [];
    const timeParts = this.state;

    this.getCounters().forEach((c, i) => {
      if (i && c !== "ampm") {
        items.push(
          <div key={`sep${i}`} className="rdtCounterSeparator">
            :
          </div>
        );
      }

      items.push(this.renderCounter(c, timeParts[c]));
    });

    return (
      <div className={`rdtTime ${this.props.dateFormat && "rdtTime-height"}`}>
        <table>
          {this.renderHeader()}
          <tbody>
            <tr>
              <td>
                <div className="rdtCounters">{items}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  renderCounter(type, value) {
    // if (type === 'hours' && this.isAMPM()) {
    // 	value = (value - 1) % 12 + 1;

    // 	if (value === 0) {
    // 		value = 12;
    // 	}
    // }

    return (
      <div key={type} className="rdtCounter">
        {/* <span
          className="icon icon-up-arrow"
          onClick={(e) => this.onStartClicking(e, "increase", type)}
        ></span> */}
        <div
          className="svg-icon rotate-icon"
          onClick={(e) => this.onStartClicking(e, "increase", type)}
        >
          <IconUpArrow />
        </div>
        <input
          className={type === "ampm" ? "rdtTime" : "rdtCount"}
          type="text"
          value={type !== "ampm" ? formatNum(value) : value}
          onChange={type !== "ampm" ? this.manuallyChange.bind(this, type) : null}
        />
        <div className="svg-icon" onClick={(e) => this.onStartClicking(e, "decrease", type)}>
          <IconUpArrow />
        </div>
        {/* <span
          className="icon icon-down-arrow"
          onClick={(e) => this.onStartClicking(e, "decrease", type)}
        ></span> */}
      </div>
    );
  }

  renderHeader() {
    if (!this.props.dateFormat) return;
    const date = this.props.selectedDate || this.props.viewDate;

    return (
      <thead>
        <tr>
          <td colSpan="4" onClick={() => this.props.showView("days")}>
            <div className="rdtSwitch">{date.format("MMM DD, YYYY")}</div>
          </td>
        </tr>
      </thead>
    );
  }

  getHours = (ampm, hours) => {
    if (hours !== 12) return parseInt(ampm.toLowerCase() === "pm" ? hours + 12 : hours, 10);
    else return parseInt(ampm.toLowerCase() === "am" ? hours - 12 : hours, 10);
  };

  onStartClicking(e, action, type) {
    let { hours, minutes, ampm } = this.state;
    let h = parseInt(hours, 10);
    let m = parseInt(minutes, 10);
    if (isNaN(h)) h = 0;
    if (isNaN(m)) m = 0;
    const date = this.props.selectedDate ? this.props.selectedDate.clone() : "";

    if (type === "hours" && action === "increase") {
      h = h + 1 > 12 ? 1 : h + 1;
      if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
        const hours = this.getHours(this.state.ampm, h);
        if (!this.props.isValidDate(date.hours(hours), true)) return;
      }
      this.setState(
        {
          hours: h,
        },
        this.cbHours
      );
    }

    if (type === "hours" && action === "decrease") {
      h = h - 1 < 1 ? 12 : h - 1;
      if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
        const hours = this.getHours(this.state.ampm, h);
        if (!this.props.isValidDate(date.hours(hours), true)) return;
      }
      this.setState(
        {
          hours: h,
        },
        this.cbHours
      );
    }

    if (type === "minutes" && action === "increase") {
      m = m + 1 > 59 ? 0 : m + 1;
      if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
        if (!this.props.isValidDate(date.minutes(m), true)) return;
      }
      this.setState(
        {
          minutes: m,
        },
        this.cbMinutes
      );
    }

    if (type === "minutes" && action === "decrease") {
      m = m - 1 < 1 ? 59 : m - 1;
      if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
        if (!this.props.isValidDate(date.minutes(m), true)) return;
      }
      this.setState(
        {
          minutes: m,
        },
        this.cbMinutes
      );
    }

    if (type === "ampm") {
      if (this.props.timeFormat.indexOf(" A") !== -1) {
        ampm = ampm === "AM" ? "PM" : "AM";
        if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
          const hours = this.getHours(ampm, this.state.hours);
          if (!this.props.isValidDate(date.hours(hours), true)) return;
        }
        this.setState(
          {
            ampm,
          },
          this.cbamAM
        );
      } else {
        ampm = ampm === "am" ? "pm" : "am";
        if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
          const hours = this.getHours(ampm, this.state.hours);
          if (!this.props.isValidDate(date.hours(hours), true)) return;
        }
        this.setState(
          {
            ampm,
          },
          this.cbamAM
        );
      }
    }
  }

  cbHours = () => {
    // this.props.setTime("hours", parseInt(this.state.hours, 10));
    if (this.state.hours !== 12)
      this.props.setTime(
        "hours",
        parseInt(
          this.state.ampm.toLowerCase() === "pm" ? this.state.hours + 12 : this.state.hours,
          10
        )
      );
    else
      this.props.setTime(
        "hours",
        parseInt(
          this.state.ampm.toLowerCase() === "am" ? this.state.hours - 12 : this.state.hours,
          10
        )
      );
  };

  cbMinutes = () => {
    this.props.setTime("minutes", parseInt(this.state.minutes, 10));
  };

  cbamAM = () => {
    if (this.state.hours !== 12)
      this.props.setTime(
        "hours",
        parseInt(
          this.state.ampm.toLowerCase() === "pm" ? this.state.hours + 12 : this.state.hours,
          10
        )
      );
    else
      this.props.setTime(
        "hours",
        parseInt(
          this.state.ampm.toLowerCase() === "am" ? this.state.hours - 12 : this.state.hours,
          10
        )
      );
  };

  manuallyChange(type, { target: { value } }) {
    if (type === "hours" && value === "0") return;
    if (type === "hours" && parseInt(value, 10) > 12) return;
    if (type === "minutes" && parseInt(value, 10) > 59) return;
    let update = {};
    update[type] = !value ? "" : parseInt(value, 10);
    const date = this.props.selectedDate ? this.props.selectedDate.clone() : "";
    if (date && this.props.isValidDate && typeof this.props.isValidDate == "function") {
      if (type === "minutes") {
        if (!this.props.isValidDate(date.minutes(update.minutes), true)) return;
      }
      if (type === "hours") {
        const hours = this.getHours(this.state.ampm, update.hours);
        if (!this.props.isValidDate(date.hours(hours), true)) return;
      }
    }
    this.setState(update);
    this.props.setTime(type, parseInt(value, 10));
  }

  toggleDayPart() {
    let hours = parseInt(this.state.hours, 10);

    if (hours >= 12) {
      hours -= 12;
    } else {
      hours += 12;
    }

    this.props.setTime("hours", hours);
  }

  increase(type) {
    const tc = this.constraints[type];
    let value = parseInt(this.state[type], 10) + tc.step;
    if (value > tc.max) value = tc.min + (value - (tc.max + 1));
    return pad(type, value);
  }

  decrease(type) {
    const tc = this.constraints[type];
    let value = parseInt(this.state[type], 10) - tc.step;
    if (value < tc.min) value = tc.max + 1 - (tc.min - value);
    return pad(type, value);
  }

  getCounters() {
    let counters = [];
    let format = this.props.timeFormat;

    if (format.toLowerCase().indexOf("h") !== -1) {
      counters.push("hours");
      if (format.indexOf("m") !== -1) {
        counters.push("minutes");
        if (format.indexOf("s") !== -1) {
          counters.push("seconds");
          if (format.indexOf("S") !== -1) {
            counters.push("milliseconds");
          }
        }
      }
    }

    if (this.isAMPM()) {
      counters.push("ampm");
    }

    return counters;
  }

  isAMPM() {
    return this.props.timeFormat.toLowerCase().indexOf(" a") !== -1;
  }

  getTimeParts(date) {
    return {
      hours: date.hours() > 12 ? date.hours() - 12 : date.hours(),
      minutes: date.minutes(),
      ampm: date.hours() >= 12 ? "PM" : "AM",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedDate && nextProps.selectedDate) {
      if (this.props.selectedDate !== nextProps.selectedDate) {
        this.setState(this.getTimeParts(this.props.selectedDate));
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedDate && this.default) {
      this.setState(this.getTimeParts(this.props.selectedDate));
      this.default = false;
    }
    // else if (prevProps.viewDate !== this.props.viewDate) {
    // 		this.setState(this.getTimeParts(this.props.viewDate));
    // }
  }
}

function pad(type, value) {
  const padValues = {
    hours: 1,
    minutes: 2,
    seconds: 2,
    milliseconds: 3,
  };

  let str = value + "";
  while (str.length < padValues[type]) str = "0" + str;
  return str;
}
